import React from 'react'
import { DialogRenderer } from '../../../legacy-design-system/action/confirmation-action'
import { ConfirmationRoleAction } from '../../../legacy-design-system/action'
import {
  ConfirmationRoleActionProps,
  Role
} from '@contrast-security-inc/base-types'
import { IconDelete } from '@contrast-security-inc/design-system-foundations'

interface DeleteActionProps extends Pick<ConfirmationRoleActionProps, 'size'> {
  readonly isActionValid: boolean
  readonly role: Role
  readonly renderDialog: DialogRenderer
}

export function DeleteAction({
  isActionValid,
  role,
  renderDialog,
  size
}: DeleteActionProps) {
  return (
    <ConfirmationRoleAction
      size={size}
      isActionValid={isActionValid}
      role={role}
      requiredRole="ADMIN"
      icon={IconDelete}
      iconTooltipMessage={{
        id: 'delete',
        defaultMessage: 'Delete'
      }}
      renderDialog={renderDialog}
      iconTooltipPlacement="top"
    />
  )
}
